export default __webpack_public_path__ + "static/toc-condensed-circles-9f51562addd7cb9d8a92527123048bd4.png";